<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="3">
          <el-step title="空运信息"></el-step>
          <el-step title="增值服务"></el-step>
          <el-step title="托运信息"></el-step>
          <el-step title="确认委托"></el-step>
          <el-step title="委托完成"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <div style="display: flex; display: -webkit-flex; align-items: center"></div>
        <div class="Item_list">
          <!-- 委托信息 -->
          <div
            style="
              display: flex;
              display: -webkit-flex;
              align-items: center;
              margin-bottom: 20px;
            "
          >
            <img src="../../assets/weituo.png" alt="订单信息" />
            <p class="tittype">订单信息</p>
          </div>
          <div class="header_text">
            <div class="count_center" style="margin-right: 50px">
              <span class="cangkutit" style="color: red; font-weight: bold">
                {{
                cangkuitem.namec
                }}
              </span>
              <span class="ckttext" style="margin-top: 10px">入仓仓库</span>
            </div>
            <div class="cangkutit" style="margin-right: 50px">
              <!-- <img src="../../assets/images/setIcon.png" alt=""> -->
              <img style="width:65px" src="../../assets/airOrder.png" alt="空运" />
            </div>
            <div class="count_center">
              <span class="cangkutit" style="color: red; font-weight: bold">{{ PScangkuitem.namec }}</span>
              <span class="ckttext" style="margin-top: 10px">目的仓库</span>
            </div>
          </div>

          <div class="good_count">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="shouMargin">货物类型：{{ goodsTypeName }}</div>
              </el-col>
              <el-col :span="8">
                <div class="shouMargin">
                  总重量：{{ goodsData.weight }}
                  <span class="ckttext">KG</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="shouMargin">
                  预计到港：
                  <span v-show="arrivaltime">{{ arrivaltime }}</span>
                  <span style="color: #ccc" v-show="!arrivaltime">
                    <i class="el-icon-loading"></i>当前暂无到港时间
                  </span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="shouMargin">
                  总箱数：{{ goodsData.piece
                  }}
                  <span
                    class="ckttext"
                    style="margin-left: 4px"
                  >箱</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="shouMargin">
                  总体积：{{ goodsData.cbm
                  }}
                  <span
                    class="ckttext"
                    style="margin-left: 4px"
                  >CBM</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="shouMargin">
                  预计开船：
                  <span v-show="sailingtime">{{ sailingtime }}</span>
                  <span style="color: #ccc" v-show="!sailingtime">
                    <i class="el-icon-loading"></i>当前暂无开船时间
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <div class>
                <span style="float: left; margin-top: 10px">货物描述：</span>
                <div style="float: left; width: 80%">
                  <el-col
                    style="margin-top: 10px"
                    :span="16"
                    v-for="(item, index) in GoodListForAir"
                    :key="index"
                  >
                    <span>
                      {{ item.goodsname }}/{{ item.piece }}件/{{
                      item.weight
                      }}KG/{{ item.cbm }}CBM
                    </span>
                  </el-col>
                </div>
              </div>
            </el-row>
          </div>
        </div>
      </div>

      <feeDetail
        :auto_fixed="auto_fixed"
        :allMoreFeeInfo="allMoreFeeInfo"
        :transportFeeForAir="transportFeeForAir"
        :pickFeeForAir="pickFeeForAir"
        :sendFeeForAir="sendFeeForAir"
        :currencyCollection="currencyCollection"
        :calculatePrice="calculatePrice"
        :feeList="feeList"
        @pathToback="pathToback"
        @pathToNext="Qdshowcount"
        :isLastStep="true"
      ></feeDetail>
    </div>

    <el-dialog title="您确认委托下述商品吗？" center :visible.sync="dialogTableVisible" width="520px">
      <div class="showDalog">
        <div class="header_text">
          <div class="count_center" style="margin-right: 50px">
            <span class="cangkutit" style="color: red">
              {{
              cangkuitem.namec
              }}
            </span>
            <span class="ckttext" style="margin-top: 10px">入仓仓库</span>
          </div>
          <div class="cangkutit" style="margin-right: 50px">
            <!-- <img src="../../assets/images/setIcon.png" alt=""> -->
            <img style="height:32px;" src="../../assets/airOrder.png" alt="空运" />
          </div>
          <div class="count_center">
            <span class="cangkutit" style="color: red">{{ PScangkuitem.namec }}</span>
            <span class="ckttext" style="margin-top: 10px">目的仓库</span>
          </div>
        </div>
        <div
          class="goodlist"
          style="
            margin-top: 40px;
            width: 100%;
            float: left;
            padding: 0px 40px;
            box-sizing: border-box;
            margin-bottom: 30px;
          "
        >
          <p style="#999999">预估费用</p>
          <div style="padding: 5px">
            <p style="font-weight: bold; color: #333333">CNY {{ calculatePrice }}</p>
          </div>
        </div>
        <div class="Qdbtn LR_center" style="margin-top: 30px">
          <div
            @click="dialogTableVisible = false"
            class="btnstyle"
            style="
              height: 35px;
              background: #ffffff;
              border: 2px solid #dcdcdc;
              border-radius: 35px;
            "
          >取消</div>
          <div
            @click="pathToNext()"
            class="btnstyle"
            style="
              border: 1px solid #5ab53c;
              font-size: 30rpx;
              background: #ff3939;
              border-color: #ff3939;
              color: #ffffff;
            "
          >确认委托</div>
        </div>
      </div>
    </el-dialog>

    <!-- 协议条款弹窗 -->
    <el-dialog title="服务条款" center :visible.sync="policyDialog" width="50%">
      <div style>
        <p style="text-align: end">编号：</p>
        <p>甲方:货代拼在线平台注册用户</p>
        <p>统一社会信用代码：</p>
        <p>地址：</p>
        <p style="margin-bottom: 20px">（以下统称“甲方”）</p>

        <p>乙方：亦邦（深圳）国际物流有限公司</p>
        <p>统一社会信用代码：91440300717851662C</p>
        <p>地址：广东省深圳市龙华区鸿荣源天骏C座39楼01-05室</p>
        <p style="margin-bottom: 20px">（以下统称“乙方”）</p>

        <p>甲、乙双方经友好协商，根据相关法律和货运行规，由甲方委托乙方代办国际航空/海洋/快递货物出口运输业务及相关单证交接、报关、境内陆路运输、货物跟踪查询、保险等辅助业务事宜达成如下协议：</p>
        <p>第一条 合作内容：</p>
        <p>乙方负责根据甲方指示，为甲方提供国际航空/海洋/快递货物出口运输业务，包括在线海运订舱/空运订舱、报关、海运/空运干线、清关和目的国境内派送/电商物流下单等相关配套服务。</p>
        <p>第二条 双方责任：</p>
        <p>2.1甲方委托乙方承运货物，甲方必须严格遵守中华人民共和国的法律、法令、规定，国际条例和交通部的有关规定。</p>
        <p>2.2甲方委托乙方出运的货物，需提前订舱，将货物资料传真至乙方，特别是超限、大票、特殊货物，甲方应事先与乙方取得联系，以便乙方安排舱位及确定是否能收运。</p>
        <p>2.3乙方负责提供运价和相关专业咨询。</p>
        <p>2.4乙方收到货物后如发现重量和尺码与订舱不符，应立即通知甲方，在得到甲方确认后才可出运。如果因甲方回复迟缓延误运输，所造成的后果由甲方负责。乙方保证在运输过程中为货物提供必要的防护、防雨、封闭空间等措施，确保货物无整箱短缺、无人为原因造成的任何损害。如有上述问题，乙方应承担货损和丢货的赔偿责任，</p>
        <p>2.5如果委托乙方代理报关，甲方应整理好报关资料，并对报关资料的准确性和真实性负责。乙方应合理审查甲方提供的单证，如发现错误需及时告知甲方修改。若甲方提供任何错误、不实、过时或不完整或具误导性的资料，由此造成的损失由甲方自行承担，乙方不承担任何相关责任。若由于乙方责任造成报关单证错误或遗失，乙方须依法向甲方承担责任。</p>
        <p>2.6乙方收到货物后及时安排出运，并将相关单据完整及时回传给甲方。</p>
        <p>2.7若乙方因各种不可抗力原因无法按预定时间出运，应及时书面或者电话通知甲方，并按甲方的合理要求采取跟进措施。</p>
        <p>2.8对由于承运人或不可抗力因素造成货物延误交货、货损等事故，按航空公司运单及相关国际航空运输公约处理善后事宜，乙方不承担责任，但应积极协助甲方解决。</p>
        <p>2.9乙方在甲方授权范围内，作为运输代理人，根据甲方合法合规且无损乙方利益的指示和要求代理甲方处理相关事宜的后果由甲方承担。乙方超越授权范围或未按照甲方指示或要求处理的相关事宜，由乙方承担全部责任。</p>
        <p>2.10乙方负责根据甲方托运单内容将甲方的货物运输至甲方的指定地点，交付甲方指定的国际运输承运公司或收货人。乙方在甲方指定装货地点装货完毕签收之时起至运抵甲方指定收货地由甲方指定的国际运输承运公司或收货人签收之时止，为乙方责任区间，由乙方负责。</p>
        <p>2.11甲方有权要求乙方按委托指令将货物运送到目的地，并有权知悉业务进展情况及服务过程；在未办理提货、发货手续之前，甲方有权变更或取消委托内容，由此产生的合理费用由甲方承担。</p>
        <p>2.12如果甲方发运的物品因甲方或与货物自身相关原因被起运港或目的港海关、相关政府部门或其他执法部门查验、扣货、销毁等，相关损失由甲方自行承担。因此给乙方造成损失的，甲方应赔偿乙方损失。如非因甲方自身原因造成前述情况的，乙方应及时通知甲方，并协助甲方积极处理，如为乙方或乙方雇佣人员或委托的第三方造成的，则乙方应向甲方承担赔偿责任。</p>
        <p>第三条 货物交接具体办法：</p>
        <p>3.1甲方发货前需真实完整地填写国际货物托运书，传真或E-MAIL给乙方。</p>
        <p>3.2乙方联系甲方确定具体的收货时间和地址或由甲方亲自送货入仓。</p>
        <p>3.3乙方根据甲方提供的报关资料制单（运单的重量以货站的核重为准）、报关。</p>
        <p>3.4乙方应在完成交货至最终收货仓后48小时内提供签收回执给甲方。</p>
        <p>第四条 收费：</p>
        <p>有关费用结算，甲方应当按双方邮件、或者书面约定的各项费用及时足额支付。乙方向甲方收取的费用，以运输前确认为主，乙方保留根据市场行情进行调整资费的权利，但必须邮件、或者书面通知甲方,并得到甲方的书面确认回复。</p>
        <p>第五条 结算：</p>
        <p>5.1双方约定采取下列第一种作为运费结算方式：</p>
        <p>第一种方式：票结。乙方每次账单确认后第一时间将账单提供给甲方进行确认，如收到后有异议须在三个工作日内反馈，超过三个工作日视为确认，核对无误后，甲方须于五个工作日向乙方结算，运费按要求超过时间未付的，乙方可采取必要途径向甲方追讨欠款，并有权追究甲方违约责任。</p>
        <p>
          第二种方式：设定最高限额的月结。
          结算期为每月1日至月末最后一天，当月最高限额为人民币100,000元，大写人民币拾万元整。如当月内甲方应付乙方的费用达到最高额度时，甲方应预先支付人民币100,000元，且在10个工作日内将此金额支付到乙方指定账户，因无理由拖欠付款产生的货物滞留等相关法律、经济责任由甲方承担。对剩余未付部份或当月未达到最高限额时按如下操作：
        </p>
        <p>
          A、乙方于每月5日前提供上月1号至月末最后一天的业务账单给甲方，甲方在收到账单之日起3个工作日内完成确认工作，以书面形式通知乙方；双方确认无误后，乙方向甲方出具正式税务发票及相关材料；甲方于收到发票起
          10个工作日内将上月1号至月末最后一天运费汇入乙方指定账户。
        </p>
        <p>
          B.
          如甲方对费用有争议，须在收到对账单后3个工作日内书面形式通知乙方，双方必须在该票业务的次月25日前（以甲方提供货物托运输的日期作为该业务的产生日期）协商确定，并于商定的付款日期内付款，以免影响次月运作；如甲方在收到对账单后3个工作日内未提出异议视为对账单所列费用已认可。
        </p>
        <p>5.2甲方应在协定时间（如遇假期顺延）内支付款项，如逾期不付，则乙方有权按拖欠时间每日加收总款项的5‰的滞纳金。甲方逾期付款超过45天以上的，乙方有权留置甲方交付的货物及与货物相关的单证（包括运输单证），责任由甲方承担。</p>
        <p>5.3运费结算方式为：现金，支票，转帐，汇至乙方指定帐户里。</p>
        <p>第六条 知识产权:</p>
        <p>6.1乙方拥有双方合作中的电子商务运营系统及其操作规范的所有知识产权，由乙方提供的包括不限于项目运营信息系统、仓储物流的有关规范、流程、图表、说明等文字知识产权属乙方独自所有，甲方不得利用技术手段予以篡改或侵犯；</p>
        <p>6.2任意一方需在得到对方的书面授权后，方可使用对方的商标、标识。任意一方并不能因为本合同自动获得对方商标、标识的使用权。</p>
        <p>第七条 保密责任</p>
        <p>7.1双方对本合同以及在履行本合同中接触到的双方的经营情况、商业信息、客户名单、技术资料等将严格保密，非经对方事先书面同意和合同正常履行之需，不得向第三方泄漏。</p>
        <p>7.2甲方承诺不披露或公开费率、条款和价格方案等，除非法律强制要求对此做出披露或公开。</p>
        <p>7.3双方应保证本方雇员履行上述义务。</p>
        <p>7.4本义务不因本合同的解除、终止、撤消而失效。</p>
        <p>第八条 违约责任：</p>
        <p>8.1甲方未按合同约定的期限向乙方支付费用，应按照实际违约天数，每日向乙方支付未付款金额的__0.05_%作为违约金。</p>
        <p>8.2因甲方提供资料不齐全而导致乙方无法完成送达任务，损失完全由甲方承担;乙方在运输过程中如果发现甲方所提供的收货人联系方式有误，应及时与甲方联系寻求解决方案，因此导致乙方未能按照约定时间交付货物，乙方不负责任，对乙方造成损失的，甲方应负责赔偿。</p>
        <p>8.3甲方如隐瞒货物属性，由此给乙方或第三人造成损失的，由甲方负全部赔偿责任。</p>
        <p>8.4其他违反合同约定行为。</p>
        <p>注：违反本合同约定的，违约方除需赔偿损失外，还应承担守约方包括但不限于诉讼费、律师费、交通费等合理损失。</p>
        <p>第九条 协议变更与解除：</p>
        <p>9.1本协议生效后，未经对方同意，任何一方不得擅自变更或解除本协议。需要变更或解除本协议时，应经双方协商一致，达成书面协议。未签署另行达成的书面协议前，本协议条款仍然有效。</p>
        <p>9.2甲乙双方任何一方有违反本协议条款时，构成根本违约时，另一方有权解除本协议，违约一方应于获取通知后的七个工作日内给另一方结算所有应付（应收）款项，并承担相应违约责任。</p>
        <p>第十条 争议解决：</p>
        <p>10.1本协议在执行过程中如发生争议，适用中华人民共和国法律解决。</p>
        <p>10.2本协议在执行过程中发生争议时，双方可协商解决；不能协商解决的，可向乙方所在地人民法院提起诉讼。</p>
        <p>10.3在上述磋商或诉讼期间，双方应继续履行争议部分之外的本合同项下各自义务。</p>
        <p>第十一条 协议生效 ：</p>
        <p>11.1本协议用户在货代拼在线平台勾选同意后生效。</p>
        <p>第十二条 其他约定：</p>
        <p style="margin-bottom: 30px">12.1本协议未尽事宜，由双方协商解决；</p>

        <p style="margin-bottom: 20px">（以下无正文，为签署页）</p>

        <p>甲方：货代拼在线平台注册用户</p>
        <p>乙方：亦邦（深圳）国际物流有限公司</p>
        <p>签订地点：深圳</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import feeDetail from "./component/fee-detail.vue"
import qs from "qs"
export default {
  components: {
    feeDetail,
  },
  data () {
    return {
      feeList: [],
      inwarehousetimeForAir: "",
      GoodListForAir: [],
      remarks: {
        remarkForSend: "",
        remarkForReceive: "",
        remarkForPick: "",
      },
      showReceive: false,
      allMoreFeeInfo: {
        amount: 0,
        totalExpense: "0",
        feeItemDTOS: [],
      },
      transportFeeForAir: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      sendFeeForAir: {
        checked: false,
        name: "",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "",
        cnyamount: "",
        amount: "",
        piece: "1",
      },
      pickFeeForAir: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
        pickUpdate: "",
      },
      policyDialog: false,
      content: "",
      getgoodsremarks: "",
      recgoodremarks: "",
      delgoodsremarks: "",
      dialogTableVisible: false,
      checkedQd: true,
      fullscreenLoading: false,

      goodsData: {
        cbm: 0,
        num: 0,
        weight: 0,
        piece: 0,
      },
      goodsTypeName: "",
      countLIst_S: JSON.parse(sessionStorage.getItem("countLIst_S")),
      countLIst_T: sessionStorage.getItem("countLIst_T")
        ? JSON.parse(sessionStorage.getItem("countLIst_T"))
        : null,
      countLIst_C: JSON.parse(sessionStorage.getItem("countLIst_C")),
      todoordate: null,
      formData: [],
      auto_fixed: false,

      cangkuitem: null,
      guojiaData: null,
      HYFmoney: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
      },
      PSFmoney: {
        checked: true,
        name: "配送费",
        feeCode: "SDYF",
        feeType: "A",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "",
        cnyamount: "",
        amount: "",
        piece: "1",
      },
      tuoCheData: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
      },
      sailingtime: "",
      arrivaltime: "",
    }
  },
  watch: {},
  computed: {
    //折合人民币
    calculatePrice () {
      let Totalmoney = 0 //总费用
      let sendFeeForAir = 0 //配送费
      let transportFeeForAir = 0 //海运费
      let THFmoney = 0 //提货费
      transportFeeForAir = this.transportFeeForAir.cnyamount
        ? this.transportFeeForAir.cnyamount
        : 0
      if (this.sendFeeForAir.checked) {
        //如果有配送费
        sendFeeForAir = this.sendFeeForAir.cnyprice
          ? this.sendFeeForAir.cnyprice
          : 0
      }
      if (this.pickFeeForAir.checked) {
        //如果有提货费
        THFmoney = this.pickFeeForAir.cnyamount
          ? this.pickFeeForAir.cnyamount
          : 0
      }

      if (transportFeeForAir) {
        Totalmoney += parseFloat(transportFeeForAir)
      }
      if (sendFeeForAir) {
        Totalmoney += parseFloat(sendFeeForAir)
      }
      if (THFmoney) {
        Totalmoney += parseFloat(THFmoney)
      }
      // 增值服务
      if (this.allMoreFeeInfo.amount > 0) {
        Totalmoney += parseFloat(this.allMoreFeeInfo.amount)
      }

      return Totalmoney.toFixed(2)
    },
    // 获得全部费用的币种
    currencyCollection () {
      let currencyAllIn = {}
      // 提货
      if (this.pickFeeForAir.currency && this.pickFeeForAir.checked) {
        if (currencyAllIn[this.pickFeeForAir.currency] === undefined) {
          currencyAllIn[this.pickFeeForAir.currency] = 0
          currencyAllIn[this.pickFeeForAir.currency] += parseFloat(
            this.pickFeeForAir.amount
          )
        } else {
          currencyAllIn[this.pickFeeForAir.currency] += parseFloat(
            this.pickFeeForAir.amount
          )
        }
      }
      // 发货
      if (this.sendFeeForAir.currency && this.sendFeeForAir.checked) {
        if (currencyAllIn[this.sendFeeForAir.currency] === undefined) {
          currencyAllIn[this.sendFeeForAir.currency] = 0
          currencyAllIn[this.sendFeeForAir.currency] += parseFloat(
            this.sendFeeForAir.amount
          )
        } else {
          currencyAllIn[this.sendFeeForAir.currency] += parseFloat(
            this.sendFeeForAir.amount
          )
        }
      }

      // 运费

      if (this.transportFeeForAir.currency) {
        if (currencyAllIn[this.transportFeeForAir.currency] === undefined) {
          currencyAllIn[this.transportFeeForAir.currency] = 0
          currencyAllIn[this.transportFeeForAir.currency] += parseFloat(
            this.transportFeeForAir.amount
          )
        } else {
          currencyAllIn[this.transportFeeForAir.currency] += parseFloat(
            this.transportFeeForAir.amount
          )
        }
      }

      // 模拟增值服务
      // let temp = [
      //   { amount: 12, currency: "USD" },
      //   { amount: 32, currency: "USD" },
      //   { amount: 32, currency: "HKD" },
      //   { amount: 32, currency: "HKD" },
      // ];

      let temp = this.allMoreFeeInfo.feeItemDTOS
      temp.forEach((item, index) => {
        if (item.checked) {
          if (currencyAllIn[item.currency] === undefined) {
            currencyAllIn[item.currency] = 0
            currencyAllIn[item.currency] += item.amount
          } else {
            currencyAllIn[item.currency] += item.amount
          }
        }
      })

      let text = ""
      Object.keys(currencyAllIn).forEach((item) => {
        text += item + currencyAllIn[item].toFixed(2) + " + "
      })

      return text.substring(0, text.length - 2)
    },
  },
  methods: {
    // 数据源[]，属性名，是否返回数组，是返回数组，否返回平好的字符串，默认返回数组
    mySet (arr, propName, wishArray = false) {
      if (!arr.length || !propName) return
      // 利用map去重
      let allKind = new Map()
      arr.forEach((item) => {
        allKind.set(item[propName], item)
      })
      if (wishArray) return allKind

      let text = ""
      allKind.forEach((item) => {
        text += item[propName] + "-"
      })
      // 截取最后 -
      return text.substr(0, text.length - 1)
    },
    openPolicy () {
      this.policyDialog = true
    },

    accAdd (arg1, arg2) {
      //加法精度
      var r1, r2, m
      try {
        r1 = arg1.toString().split(".")[1].length
      } catch (e) {
        r1 = 0
      }
      try {
        r2 = arg2.toString().split(".")[1].length
      } catch (e) {
        r2 = 0
      }
      m = Math.pow(10, Math.max(r1, r2))
      return (arg1 * m + arg2 * m) / m
    },


    getShowcount () {
      this.GoodListForAir.forEach((item) => {
        console.log(item)
        this.goodsData.weight += parseFloat(+item.weight)
        this.goodsData.cbm += parseFloat(+item.cbm)
        this.goodsData.piece += parseFloat(item.piece)
      })
    },
    pathToback () {
      this.$router.go(-1)
    },
    Qdshowcount () {
      if (!this.checkedQd) {
        return this.$message({
          showClose: true,
          message: "请先同意协议",
          type: "error",
        })
      }

      if (JSON.parse(sessionStorage.getItem("sendFeeForAir")).checked) {
        this.Getcounttext()
      } else {
        this.dialogTableVisible = true
      }
    },
    Getcounttext () {
      //验证目的仓库与收货人国家是否匹配
      let params = {}

      params = {
        recgoodsCountry: this.sendFeeForAir.country,
        toWarehouseId: JSON.parse(sessionStorage.getItem("PScangkuitem")).id,
      }

      this.axios
        .post(
          `/busLcljobsBefore/validateWarehouseCountry`,
          qs.stringify(params),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          console.log(res)
          if (res.data.code == "200") {
            this.dialogTableVisible = true
          } else {
            this.$alert(res.data.message, "提示", {
              confirmButtonText: "确定",
            })
          }
        })
        .catch((res) => {
          console.log(res)
        })
    },
    pathToNext () {
      //下单
      if (!this.checkedQd) {
        return this.$message({
          showClose: true,
          message: "请先同意协议",
          type: "error",
        })
      }

      this.dialogTableVisible = true


      const loading = this.$loading({
        lock: true,
        text: "下单中请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let params = {
        // 委托货品列表
        busAirjobsBeforeGoodsDTOList: JSON.parse(
          sessionStorage.getItem("GoodListForAir")
        ),

        customerId: this.sessionGetUserInfo()
          .customerid, //客户id

        // 运费
        finaArapAirBeforeAFFDTO:
          JSON.parse(sessionStorage.getItem("transportFeeForAir")) || {},
        // 附加服务费用列表
        finaArapAirBeforeDTOList: this.feeList || [],
        // 派送费
        finaArapAirBeforeSDYFDTO:
          JSON.parse(sessionStorage.getItem("sendFeeForAir")) || {},
        // 提货费
        finaArapAirBeforeTHFDTO:
          JSON.parse(sessionStorage.getItem("pickFeeForAir")) || {},
        // 发货地址
        delGoodsDTO: {
          delGoodsId: this.countLIst_S.id || "",
          delGoodsName: this.countLIst_S.name || "",
          delGoodsRemarks: this.remarksForAir.remarkForSend || "",
          delGoodsTel: this.countLIst_S.tel || "",
        },
        // 提货地址
        getGoodsDTO: {
          //提货地址
          getGoodsAddress: this.pickFeeForAir.address || "",
          getGoodsArea: this.pickFeeForAir.area || "",
          getGoodsCity: this.pickFeeForAir.city || "",
          getGoodsId: this.pickFeeForAir.id || "",
          getGoodsName: this.pickFeeForAir.name || "",
          getGoodsProvince: this.pickFeeForAir.parvince || "",
          getGoodsRemarks: this.remarksForAir.remarkForPick || "",
          getGoodsTel: this.pickFeeForAir.tel || "",
        },
        // 入仓仓库id
        inWarehouseId: JSON.parse(sessionStorage.getItem("cangkuitem")).id,
        // 入仓时间
        inWarehouseTime: sessionStorage.getItem("inwarehousetime") || "",
        // 是否上门取件
        isGetGoodsToDoor:
          (JSON.parse(sessionStorage.getItem("pickFeeForAir")) &&
            JSON.parse(sessionStorage.getItem("pickFeeForAir")).checked) ||
          false,
        // 是否上门取件
        isSendGoodsToDoor:
          (JSON.parse(sessionStorage.getItem("sendFeeForAir")) &&
            JSON.parse(sessionStorage.getItem("sendFeeForAir")).checked) ||
          false,
        // 派送地址
        recGoodsDTO: {
          recGoodsAddress:
            (JSON.parse(sessionStorage.getItem("sendFeeForAir")) &&
              JSON.parse(sessionStorage.getItem("sendFeeForAir")).address) ||
            "",
          recGoodsArea:
            (JSON.parse(sessionStorage.getItem("sendFeeForAir")) &&
              JSON.parse(sessionStorage.getItem("sendFeeForAir")).area) ||
            "",
          recGoodsCity:
            (JSON.parse(sessionStorage.getItem("sendFeeForAir")) &&
              JSON.parse(sessionStorage.getItem("sendFeeForAir")).city) ||
            "",
          recGoodsCountry:
            (JSON.parse(sessionStorage.getItem("sendFeeForAir")) &&
              JSON.parse(sessionStorage.getItem("sendFeeForAir")).country) ||
            "",
          recGoodsId:
            (JSON.parse(sessionStorage.getItem("sendFeeForAir")) &&
              JSON.parse(sessionStorage.getItem("sendFeeForAir")).id) ||
            "",
          recGoodsName:
            (JSON.parse(sessionStorage.getItem("sendFeeForAir")) &&
              JSON.parse(sessionStorage.getItem("sendFeeForAir")).name) ||
            "",
          recGoodsRemarks: this.remarksForAir.remarkForReceive || "",
          recGoodsTel:
            (JSON.parse(sessionStorage.getItem("sendFeeForAir")) &&
              JSON.parse(sessionStorage.getItem("sendFeeForAir")).tel) ||
            "",
        },
        // 工作单备注
        remarks: "",

        saleId: this.sessionGetUserInfo().salesid,
        source: "WEB",
        // 上门取件时间
        toDoorDate: this.pickFeeForAir.pickUpdate,
        //目的地仓库
        toWarehouseId: JSON.parse(sessionStorage.getItem("PScangkuitem")).id,
      }
      this.axios
        .post(`/busKY/createKYJobsBefore`, params)
        .then((res) => {
          if (res.data.code == "200") {
            console.log(res.data.data.innos)
            loading.close()
            this.$router.push({
              name: "AirOrderSuccess",
              query: {
                state: 1,
                innos: res.data.data.nos,
                nos: res.data.data.innos,
                id: res.data.data.id,
              },
            })
          } else {
            loading.close()
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error",
            })
          }
        })
        .catch((res) => {
          console.log(res)
        })
    },
    onScroll () {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop
      // 计算A区的高度
      let header_height = null
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height = document.getElementsByClassName("wrap_R")[0]
          .offsetHeight
      }
      // if (scrolled >= 400) {
      //   this.auto_fixed = true;
      // } else {
      //   this.auto_fixed = false;
      // }
    },
  },
  created () {
    this.cangkuitem = JSON.parse(sessionStorage.getItem("cangkuitem"))
    this.PScangkuitem = JSON.parse(sessionStorage.getItem("PScangkuitem"))
    // jack
    if (sessionStorage.getItem("transportFeeForAir")) {
      //运输费
      this.transportFeeForAir = JSON.parse(
        sessionStorage.getItem("transportFeeForAir")
      )
    }
    if (sessionStorage.getItem("sendFeeForAir")) {
      this.sendFeeForAir = JSON.parse(sessionStorage.getItem("sendFeeForAir"))
    }
    if (sessionStorage.getItem("pickFeeForAir")) {
      this.pickFeeForAir = JSON.parse(sessionStorage.getItem("pickFeeForAir"))
    }
    if (sessionStorage.getItem("remarksForAir")) {
      this.remarksForAir = JSON.parse(sessionStorage.getItem("remarksForAir"))
    }
    if (sessionStorage.getItem("inwarehousetimeForAir")) {
      this.inwarehousetimeForAir = JSON.parse(
        sessionStorage.getItem("inwarehousetimeForAir")
      )
    }
    // 获取货物类型名称
    if (sessionStorage.getItem("GoodListForAir")) {
      this.GoodListForAir = JSON.parse(sessionStorage.getItem("GoodListForAir"))
      this.goodsTypeName = this.mySet(
        JSON.parse(sessionStorage.getItem("GoodListForAir")),
        "goodstype"
      )
    }
    if (sessionStorage.getItem("moreFeeListForAir")) {
      this.feeList = JSON.parse(
        sessionStorage.getItem("moreFeeListForAir")
      ).feeItemDTOS
      this.allMoreFeeInfo = JSON.parse(
        sessionStorage.getItem("moreFeeListForAir")
      )
    }
  },
  mounted () {
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll)
    })
    this.getShowcount()
    // this.getAgingInTime();
  },
};
</script>
<style scoped>
.btnstyle {
  width: 150px;
  height: 35px;
  background: #ffffff;
  border: 2px solid #dcdcdc;
  border-radius: 35px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.Qdbtn {
  width: 100%;
  padding: 0 60px;
  box-sizing: border-box;
}
.fontString {
  font-weight: bold;
}
.shouMargin {
  margin-bottom: 10px;
}
.ckttext {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #9a9a9a;
}
.good_count {
  margin-top: 65px;
}
.header_text {
  text-align: center;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.count {
  width: 100%;
  padding-top: 30px;
}
.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}
.dialog >>> .el-dialog__header {
  padding: 10px !important;
}
.tittype {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left: 10px;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 778px;
}
/* 左右对齐 */
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.popWrap_l {
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}
.Item_Right {
  float: left;
}
.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}
.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}

.center_wrap {
  width: 1098px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 24px 28px 12px 28px;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  margin-bottom: 15px;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.wrap_l {
  float: left;
  width: 764px;
  background: #ffffff;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.wrap_R {
  float: right;
  width: 320px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}
.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
/* table 滚动条 */
.OrderDetails {
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
}
.OrderDetails::-webkit-scrollbar {
  width: 3px;
}
.OrderDetails::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.OrderDetails::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/airOrder/AirConfirmPage.vue